export { goToRoute } from './routeActions';

export { setMinimizedView, closeSideBar, openSideBar } from './viewActions';



// WEBPACK FOOTER //
// ./application/actions/index.js